/* eslint-disable import/no-anonymous-default-export */
import MainLayout from "../../../_components/Common/MainLayout";
import { Container, Tab, Nav, Spinner } from "react-bootstrap";
import useViewCandidates from "./useViewCandidates";
import { dateDiff } from "../../../_helpers/dateFormatter";

import {
  ShortlistedCandidates,
  AcceptedCandidates,
  AllCandidates,
  CompletedCandidates,
  DeclinedCandidates,
  SuggestedCandidates,
} from "./_components";
import ShareLink from "../../../_uiComponents/ShareLink";
import { appRoutes } from "../../../_routes/app-routes";
import useCopyToClipboard from "../../../_hooks/useCopyToClipboard";

export default () => {
  const {
    assessmentData,
    candidateListData,
    loading,
    isCandidateLoading,
    user,
    onTabchangeHandler,
    onEditKitClick,
    onAssessmentShareClick,
    onViewCandidateResponseClick,
    getStatusCount,

    isShortlistRejectModal,
    handleShortlistRejectModal,
    shortlistRejectType,
    onBlurInput,
    assessementDetails,
    shortlistRejectClick,

    isInvitationModal,
    handleInvitationModal,
    handleInviteSuccessModal,
    isInviteSuccessModal,
    isCreateAssessmentModal,
    handleCreateAssessmentModal,
    onAssignAssessmentClick,
    assignmentUserId,
    suggestedCandidates,
    showSearch,
    searchInputRef2,
    totalCandidates
  } = useViewCandidates();

  const { getWebUrl } = useCopyToClipboard();

  return (
    <MainLayout pageName={"Assigned Candidates"}>
      {loading ? (
        <div className="text-center">
          <Spinner variant="primary" />
        </div>
      ) : (
        <>
          <div className="top pb-2">
            <Container>
              <div className="d-flex flex-column p-4 bg-white border position-relative h-100 border-radius-10">
                <div className="upper">
                  <div className="d-flex justify-content-between">
                    <div className="job-info">
                      <h3 className="text-dark mb-1 text-capitalize ">
                        {assessmentData?.title}
                      </h3>
                    </div>
                    <div className="d-flex align-items-center">
                      <button
                        className="bg-transparent border-0 text-dark"
                        title="Copy"
                        onClick={() =>
                          onAssessmentShareClick(assessmentData?.hash_id)
                        }
                      >
                        <img src="/assets/images/copy-icon.svg" alt="edit" />
                      </button>

                      <button
                        className="bg-transparent border-0 text-dark"
                        title="Edit"
                        onClick={() => {
                          onEditKitClick(assessmentData?.id);
                        }}
                      >
                        <img src="/assets/images/edit-grey.svg" alt="edit" />
                      </button>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="d-flex align-items-center fs-smallest  justify-content-between">
                      <p className="text-grey-4">
                        {Array.isArray(assessmentData?.skills) && (
                          <span className="border d-inline-block rounded-lg p-1 mr-2">
                            Skills{" "}
                            <span className="font-weight-medium text-dark bg-grey rounded-lg py-1 px-2">
                              {assessmentData.skills.length}
                            </span>{" "}
                          </span>
                        )}
                        <span className="border mr-2 d-inline-block rounded-lg p-1">
                          Total Questions{" "}
                          <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                            {assessmentData?.total_questions}
                          </span>{" "}
                        </span>
                        <span className="border  d-inline-block rounded-lg p-1">
                          Total Candidates{" "}
                          <span className="font-weight-medium  text-dark  bg-grey rounded-lg py-1 px-2">
                            {totalCandidates()}
                          </span>{" "}
                        </span>
                      </p>
                    </div>

                    <div className="mb-2">
                      <span className="border d-inline-block rounded-pill bg-grey-3 px-2 py-1 fs-smallest mr-2 mb-2">
                        Assigned{" "}
                        <span className="custom-tag tag-offer font-weight-medium  px-2 rounded-pill">
                          {getStatusCount("assigned")}
                        </span>
                      </span>
                      <span className="border d-inline-block rounded-pill bg-grey-3 px-2 py-1 fs-smallest mr-2 mb-2">
                        Accepted{" "}
                        <span className="custom-tag tag-applied font-weight-medium  px-2 rounded-pill">
                          {getStatusCount("accepted")}
                        </span>
                      </span>
                      <span className="border d-inline-block rounded-pill bg-grey-3 px-2 py-1 fs-smallest mr-2 mb-2">
                        Completed{" "}
                        <span className="custom-tag tag-interview font-weight-medium  px-2 rounded-pill">
                          {getStatusCount("completed")}
                        </span>
                      </span>
                      <span className="border d-inline-block rounded-pill bg-grey-3 px-2 py-1 fs-smallest mr-2 mb-2">
                        Shortlisted{" "}
                        <span className="custom-tag tag-green font-weight-medium  px-2 rounded-pill">
                          {getStatusCount("shortlisted")}
                        </span>
                      </span>
                    </div>

                    <div className="d-flex align-items-center flex-wrap fs-smallest mb-2">
                      <p className=" mr-2 text-capitalize mb-0">
                        {Array.isArray(assessmentData?.skills) &&
                          assessmentData?.skills.map((skill) => (
                            <span className="border d-inline-block rounded bg-grey-3 px-1 py-1 fs-smallest mr-2 mb-2">
                              {skill?.skill_id && skill?.skill_id?.skill}
                              <span className="custom-tag tag-green font-weight-medium ml-1 px-2 rounded">
                                {skill?.difficulty_level}
                              </span>
                            </span>
                          ))}
                      </p>
                    </div>

                    {assessmentData?.additional_notes && (
                      <p className="fs-smallest mb-2">
                        <strong>Addtional Notes</strong>:
                        <div
                          dangerouslySetInnerHTML={{
                            __html: assessmentData?.additional_notes && assessmentData.additional_notes.substring(
                              0,
                              100
                            ) + "..."
                          }}
                        />
                      </p>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-center border-top flex-md-wrap flex-lg-nowrap mt-auto">
                  <p className="mb-0 mr-2  text-grey-4 fs-smallest pt-3">
                    Created{" "}
                    {assessmentData?.created_at &&
                      dateDiff(assessmentData?.created_at, new Date())}{" "}
                    ago
                  </p>
                  <div className="mt-2">
                    <ShareLink
                      link={`${getWebUrl()}${appRoutes.assessementKit.assessmentPublicDetails.replace(
                        ":id",
                        assessmentData?.hash_id
                      )}`}
                      message={`Jigsaw send invite of a Assessment kit, please check the link`}
                    />
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className="kanban-board-main mt-4 pb-4">
            <div className="container">
              <div className="new-listing-section bg-white">
                <Tab.Container
                  id="left-tabs-example"
                  defaultActiveKey="all"
                  onSelect={(k) => onTabchangeHandler(k)}
                >
                  <div className="border rounded-lg">
                    <div className="d-flex align-items-center p-3 ">
                      <Nav variant="pills" className="tab-style-2">
                        <Nav.Item>
                          <Nav.Link eventKey="all">
                            All{" "}
                            <span className="text-black">
                              ({totalCandidates()})
                            </span>
                          </Nav.Link>
                        </Nav.Item>

                        <Nav.Item>
                          <Nav.Link eventKey="completed">
                            Completed{" "}
                            <span className="text-black">
                              ({getStatusCount("completed")})
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="shortlisted">
                            Shortlisted{" "}
                            <span className="text-black">
                              ({getStatusCount("shortlisted")})
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                        {/* <Nav.Item>
                          <Nav.Link eventKey="declined">Declined</Nav.Link>
                        </Nav.Item> */}
                        <Nav.Item>
                          <Nav.Link eventKey="suggested">
                            Suggested{" "}
                            <span className="text-black">
                              (
                              {Array.isArray(suggestedCandidates) &&
                              suggestedCandidates.length
                                ? suggestedCandidates.length
                                : 0}
                              )
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      {/* 
                      <div className="custom-search-box ml-auto">
                        <div className="search-box-with-icon">
                          <span className="icon">
                            <img
                              src="/assets/images/search-lg-icon.svg"
                              alt="search"
                            />
                          </span>
                          <input type="text" placeholder="Search" />
                        </div>
                        <button>
                          <img
                            src="/assets/images/filter-lines.svg"
                            alt="filter"
                          />
                          Filters
                        </button>
                      </div> */}
                    </div>
                    <Tab.Content>
                      <Tab.Pane eventKey="all">
                        <AllCandidates
                          candidateListData={candidateListData}
                          onViewCandidateResponseClick={
                            onViewCandidateResponseClick
                          }
                          isCandidateLoading={isCandidateLoading}
                          user={user}
                        />
                      </Tab.Pane>

                      <Tab.Pane eventKey="accepted">
                        <AcceptedCandidates
                          candidateListData={candidateListData}
                          onViewCandidateResponseClick={
                            onViewCandidateResponseClick
                          }
                          isCandidateLoading={isCandidateLoading}
                        />
                      </Tab.Pane>

                      <Tab.Pane eventKey="shortlisted">
                        <ShortlistedCandidates
                          candidateListData={candidateListData}
                          onViewCandidateResponseClick={
                            onViewCandidateResponseClick
                          }
                          isCandidateLoading={isCandidateLoading}
                          user={user}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="declined">
                        <DeclinedCandidates
                          candidateListData={candidateListData}
                          onViewCandidateResponseClick={
                            onViewCandidateResponseClick
                          }
                          isCandidateLoading={isCandidateLoading}
                        />
                      </Tab.Pane>

                      {/*  */}
                      <Tab.Pane eventKey="suggested">
                        <SuggestedCandidates
                          assessmentData={assessmentData}
                          isInvitationModal={isInvitationModal}
                          handleInvitationModal={handleInvitationModal}
                          handleInviteSuccessModal={handleInviteSuccessModal}
                          isInviteSuccessModal={isInviteSuccessModal}
                          isCreateAssessmentModal={isCreateAssessmentModal}
                          handleCreateAssessmentModal={
                            handleCreateAssessmentModal
                          }
                          onAssignAssessmentClick={onAssignAssessmentClick}
                          assignmentUserId={assignmentUserId}
                          suggestedCandidates={suggestedCandidates}
                          showSearch={showSearch}
                          searchInputRef2={searchInputRef2}
                        />
                      </Tab.Pane>
                      <Tab.Pane eventKey="completed">
                        <CompletedCandidates
                          candidateListData={candidateListData}
                          onViewCandidateResponseClick={
                            onViewCandidateResponseClick
                          }
                          isCandidateLoading={isCandidateLoading}
                          isShortlistRejectModal={isShortlistRejectModal}
                          handleShortlistRejectModal={
                            handleShortlistRejectModal
                          }
                          shortlistRejectType={shortlistRejectType}
                          onBlurInput={onBlurInput}
                          assessementDetails={assessementDetails}
                          shortlistRejectClick={shortlistRejectClick}
                          user={user}
                        />
                      </Tab.Pane>
                    </Tab.Content>
                  </div>
                </Tab.Container>
              </div>
            </div>
          </div>
        </>
      )}
    </MainLayout>
  );
};
